import { Builder, withChildren } from '@builder.io/react';

import Section from './index';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'Section',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: ['bg-transparent', 'bg-gray-950', 'bg-gray-900', 'bg-gray-100', 'bg-gray-800']
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle'
      }
    }
  ]
});
